<h1 class="text-center m-4">{{ highlightId ? 'Edit Centre Highlight' : 'Add Centre Highlight' }}</h1>
<main class="container-fluid">
  <!--    <prettyjson [obj]="centerHighlightForm.value"></prettyjson>-->
  <form [formGroup]="centerHighlightForm" (ngSubmit)="onSubmit()">
    <div class="m-2">
      <div class="card mx-2">
        <div class="row mx-3 mt-4">
          <!-- Centre Name Dropdown -->
          <mat-form-field appearance="outline" class="col-md-3 col-sm-12">
            <mat-label>Centre Name</mat-label>
            <ng-container *ngIf="!highlightId else center">
              <mat-select formControlName="centreCode" >
                <mat-option *ngFor="let c of centres$ | async" [value]="c.centreCode">{{ c.centreName }}</mat-option>
              </mat-select>
            </ng-container>
            <ng-template #center>
              <input matInput formControlName="centreCode" readonly/>
            </ng-template>
          </mat-form-field>

          <!-- Highlight Dropdown -->
          <mat-form-field appearance="outline" class="col-md-3 col-sm-12" *ngIf="!highlightId">
            <mat-label>Highlight</mat-label>
            <ng-container>
              <mat-select formControlName="highlight">
                <mat-option *ngFor="let highlight of highlighTypeList$ | async" [value]="highlight">
                  {{ highlight }}
                </mat-option>
              </mat-select>
            </ng-container>
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="highlightId && mHightlights.length == 1"  class="col-md-3 col-sm-12">
            <mat-label>Highlight</mat-label>
            <mat-select formControlName="highlight">
              <mat-option *ngFor="let h of highlighTypeList$|async" [value]="h">{{ h }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Event Date Picker -->
          <mat-form-field appearance="outline" class="col-md-3 col-sm-12">
            <mat-label>Event Date</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="eventDate" placeholder="Event Date" required>
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Narrative Editor Section -->
        <div class="mx-4 mb-3">
          <label class="fw-bold">Narrative:</label>
<!--          <p-editor formControlName="narrative" [style]="{ height: '250px' }"></p-editor>-->
          <ckeditor
            [editor]="Editor"
            formControlName="narrative"
            style="height: 300px"
          ></ckeditor>
        </div>
        <ng-container *ngIf="mHightlights.length>1">
          <div class="m-4">
            <table mat-table [dataSource]="mHightlights" class="mat-elevation-z8">

              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef> No.</th>
                <td mat-cell *matCellDef="let element;let i = index"  > {{ i+1 }}</td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="addedBy">
                <th mat-header-cell *matHeaderCellDef> Added By</th>
                <td mat-cell *matCellDef="let element"> {{ element.addedBy }}</td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="centreCode">
                <th mat-header-cell *matHeaderCellDef> Centre </th>
                <td mat-cell *matCellDef="let element"> {{ element.centreCode }}</td>
              </ng-container>
              <!-- Symbol Column -->
              <ng-container matColumnDef="narrative">
                <th mat-header-cell *matHeaderCellDef> Narrative</th>
                <td mat-cell *matCellDef="let element" [innerHTML]="element.narrative"> {{ element.narrative }}</td>
              </ng-container>
              <ng-container matColumnDef="highlight">
                <th mat-header-cell *matHeaderCellDef> Highlight</th>
                <td mat-cell *matCellDef="let element"> {{ element.highlight }}</td>
              </ng-container>
              <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef> Date</th>
                <td mat-cell *matCellDef="let element"> {{ element?.createdAt.toDate()|date:'dd-MM-yyyy' }}</td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element ; let i= index">
                  <button mat-icon-button (click)="editDialog(element,i)" color="primary"> <mat-icon>edit</mat-icon></button>
                  <button mat-icon-button (click)="deleteItem(element, i)" color="warn">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </ng-container>


        <!-- Submit and Download Buttons -->
        <div class="d-flex justify-content-center">
          <button mat-raised-button color="warn" class="m-2 col-md-2" type="button" (click)="cancel()">Cancel
          </button>
          <button mat-raised-button color="primary" class="m-2 col-md-2"
                  type="submit">{{ highlightId ? 'Update' : 'Submit' }}
          </button>
        </div>
      </div>
    </div>
  </form>
</main>
